import React from 'react'
import styles from './wallet.module.css'
import Text from '../text/Text'
import Wallet1 from '../../assets/images/wallets/wallet-1.svg'

interface WalletProperties {
    design?: 'secondary'
    type?: string
    name: string
    number: string
    style?: React.CSSProperties
}

export function Wallet(properties: WalletProperties) {
    return (
        <div className={styles.container} style={properties.style}>
            <div className={styles.contentImage}>
                <div
                    className={
                        properties.design === 'secondary'
                            ? styles.circleImage
                            : styles.noCircleImage
                    }
                >
                    <img
                        src={Wallet1}
                        alt="wallet"
                        style={
                            properties.design === 'secondary'
                                ? { width: 35, height: 23 }
                                : {}
                        }
                    />
                </div>
            </div>
            <div className={styles.content}>
                <Text
                    label={properties.name}
                    fontWeight={800}
                    color="#565656"
                    fontSize={14}
                />
                <Text
                    label={properties.number}
                    fontWeight={800}
                    color="#565656"
                    fontSize={14}
                />
            </div>
        </div>
    )
}
